import config from 'config';
import { CognitoTokenManager } from 'app/modules/auth';
import RequestHeaders from 'app/constants/requestHeaders';
import { DEFAULT_HEADERS } from 'constants/request';
import { isHttpUrl } from 'app/utils/reportPdfExport';
import store from 'store';
import type { ReportFormat } from './types';

const REPORTS_BASE_PATH = '/reports';

export async function resolveReportDownloadRedirectUrl(
  reportId: number,
  format: ReportFormat,
): Promise<string | null> {
  const authToken = store.getState().app.authToken;
  const accountId = CognitoTokenManager.getSelectedAccountId();

  const headers: Record<string, string> = {
    ...DEFAULT_HEADERS,
  };

  if (accountId) {
    headers[RequestHeaders.AccountId] = String(accountId);
  }

  if (authToken) {
    headers[RequestHeaders.HttpJwtToken] = authToken;
  }

  try {
    const response = await fetch(
      `${config.API_SERVICE_ENDPOINT}${REPORTS_BASE_PATH}/${reportId}/download/${format}`,
      {
        method: 'GET',
        redirect: 'follow',
        headers,
      },
    );

    const finalUrl = response.url;
    return isHttpUrl(finalUrl) ? finalUrl : null;
  } catch {
    return null;
  }
}
